import * as React from 'react'
import './Question.css'

type toastProps = {
  title: string
  children: React.ReactNode
}

const Question = ({ title, children }: toastProps): JSX.Element => {
  return (
    <div className="question">
      <h2>{title}</h2>
      {children}
    </div>
  )
}

export default Question
